import allImgPaths from "assets/images";
import React, { useState } from "react";
import InsightCardsOptions from "./InsightCardsOptions";
import StackedBarChart from "components/common/charts/StackedBarChart";
import { Modal } from "components/common/modal/Modal";
import { Body } from "components/common/modal/Body";

const ContractInvoice = () => {
  const [showOptions, setShowOptions] = useState(false);
  const [openMaximizeModal, setOpenMaximizeModal] = useState(false);

  const MaximizeModal = () => {
    return (
      <Modal className={"modal-wrapper max-w-[690px] relative"} isShow={openMaximizeModal}>
		<img
			className="cursor-pointer absolute top-3 right-3"
			id="modal-toggle"
			src={allImgPaths.closeIcon}
			onClick={() => setOpenMaximizeModal(false)}
			alt="close icon"
		/>
        <Body title="header" isShowBody={true} className="">
           <div className="bg-[#fff] rounded-xl p-4">
            <div className="flex items-center justify-between w-full">
              <div className="flex items-center gap-x-2">
                <h4 className="text-base font-interSemiBold text-[#101828]">Contract vs Invoice</h4>
                <div className="">
                  <img className="cursor-pointer" src={allImgPaths.questionMarkIcon} alt="" />
                </div>
              </div>
            </div>
           
            <StackedBarChart />
          </div> 
        </Body>
      </Modal>
    );
  };

  return (
    <>
      <div className="bg-[#fff] rounded-xl border border-[#EAECF0] px-6 pt-3 w-[calc(33%_-_12px)]">
        <div className="flex items-center justify-between w-full">
          <div className="flex items-center gap-x-2">
            <h4 className="text-base font-interSemiBold text-[#101828]">Contract vs Invoice</h4>
            <div className="">
              <img className="cursor-pointer" src={allImgPaths.questionMarkIcon} alt="" />
            </div>
          </div>

          <div
            className='p-1 cursor-pointer relative hover:bg-[#f2f4f7] rounded w-5 focus-within:bg-[#f2f4f7]'
            onClick={() => setShowOptions(!showOptions)}
          >
            <img className="mx-auto" src={allImgPaths.threeVerticleDotsIcon} alt="three dots" />
            <InsightCardsOptions
              isShow={showOptions}
              openMaximizeModal={() => setOpenMaximizeModal(true)}
              chartName='stack_bar_chart'
              downloadChartName='contract'
            />
          </div>
        </div>

        {/* Bar Graph */}
        <StackedBarChart />
      </div>
      <MaximizeModal />
    </>
  );
};

export default ContractInvoice;
